import { createFileRoute, redirect } from '@tanstack/react-router';
import { CabinetLayout } from '@/widgets/CabinetLayout';
import { LocalStorageKeys } from '@/app/localStorage/types.ts';
import { getURLSearchParams } from '@/shared/lib/urlService.ts';
import { postLoginByHash } from '@/features/auth/api/requests.ts';
import { authStore } from '@/app/localStorage/utils.ts';

export const Route = createFileRoute('/_layout/cabinet')({
  component: CabinetLayout,
  loader: async ({ preload }) => {
    if (preload) {
      return;
    }

    const hashStorage = localStorage.getItem(LocalStorageKeys.Hash);
    const { hash: hashUrl } = getURLSearchParams();
    const hash = hashUrl || hashStorage;

    if (hash) {
      const response = await postLoginByHash({ hash });
      const token = response.data.token;

      if (token) {
        authStore.setToken(token);
        localStorage.removeItem(LocalStorageKeys.Hash);

        throw redirect({
          to: '/cabinet/applications',
          search: { shouldOpenApplication: true },
        });
      }
    }

    const storageToken = authStore.getToken();
    if (!storageToken) {
      throw redirect({ to: '/auth' });
    }
  },
});
